import { Pipe, PipeTransform } from '@angular/core'
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber'

@Pipe({
    name: 'phoneNumber',
    standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {

    transform(
        phoneNumber: string | null,
        fallbackCountryCode: string = 'GB'
    ): string | null {
        if (!phoneNumber) {
            return null
        }
        try {
            const phoneUtil = PhoneNumberUtil.getInstance()
            const number = phoneUtil.parse(phoneNumber, fallbackCountryCode)
            return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL)
        } catch {
            return phoneNumber
        }
    }
}
